module.exports = __webpack_public_path__ + "static/img/fassaden1.7f4e7d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handwerk/fassaden1.jpg
// module id = p6Z8
// module chunks = 1